import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import PersonalLinkIconSelector from './personalLinkIconSelector';
import { DragHandler } from '../../../../../../editJournal/toolset/assets/icons';
import Actions from '../../../../../../../../../store/actions';
import SnackBarAlerts from '../../../../../../../../common/snackBarAlerts/snackBarAlerts';
import {
  ArrayItemWrapper,
  DragWrapper,
} from '../../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/arrayItems';
import dragStart from './onDragStart';
import dragEnd from './onDragEnd';
import Input from './input';
import { FormatTypes } from '../../../../../../../../../constants/templateDictionaries';
import Export from './export';
import { isSafari } from '../../../../../../../../../utility/browsers';

class ArrayItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      noDrag: false,
      snackBar: null,
    };
  }

  onDragStart = (e) => {
    const { noDrag } = this.state;

    const nativeSelection =
      window &&
      window.getSelection() &&
      window.getSelection().toString().length;
    if (nativeSelection) {
      e.preventDefault();
      return;
    }

    const { nodeProps, setDrag, activePlan, subscriptionStatus, formatType } =
      this.props;

    const {
      node: { type: nodeType },
    } = nodeProps;

    const dragType = this.getDragType(nodeType);
    if (dragType === 'ROLE_ARRAY_ITEM') {
      setTimeout(() => {
        const { editor } = nodeProps;
        const {
          value: {
            document: { nodes },
          },
        } = editor;
        const orgNodesArray = nodes.toArray();
        orgNodesArray.forEach((orgNode) => {
          const { key: orgKey, data: orgData } = orgNode;
          const orgDataJSON = orgData.toJSON();
          const { isCollapseChildren } = orgDataJSON;
          if (isCollapseChildren) {
            editor
              .setNodeByKey(orgKey, {
                data: {
                  ...orgDataJSON,
                  isCollapseChildren: false,
                },
              })
              .blur();
          }
        });
      });
    }

    dragStart({
      e,
      noDrag,
      setDragState: this.setDragState,
      setDrag,
      nodeProps,
      getDragType: this.getDragType,
      setSnackBar: this.setSnackBar,
      activePlan,
      subscriptionStatus,
      formatType,
    });
  };

  onDragEnd = (e) => {
    const { nodeProps, setDrag, dragOverCords } = this.props;

    dragEnd({
      e,
      nodeProps,
      setDrag,
      getDragType: this.getDragType,
      setSnackBar: this.setSnackBar,
      dragOverCords,
    });
  };

  setDragState = (val) =>
    this.setState({
      noDrag: val,
    });

  stopDrag = () => this.setDragState(true);

  setSnackBar = (type) => {
    if (type === 'error')
      this.setState({
        snackBar: {
          showSnackBar: true,
          snackBarMessage: 'Please, retry the dragging!',
          snackBarType: 'error',
          errorCode: 'drag',
        },
      });
  };

  getDragType = (nodeType) =>
    nodeType === 'skill_title' ? 'ROLE_ARRAY_ITEM' : 'ARRAY_ITEM';

  render() {
    const { snackBar } = this.state;
    const {
      nodeProps,
      placeHolder,
      userPreferences,
      formatType,
      statusBarRef,
      mostUsedToolSetRef,
      showRatings,
      sectionKey,
    } = this.props;
    const { editor, node, attributes, isFocused } = nodeProps;

    const { type: currentNodeType } = node;

    const {
      value: { document },
    } = editor;

    const organization = document && document.getParent(node.key);
    let rolesCount = 0;
    if (currentNodeType.includes('skill')) {
      rolesCount = organization && organization.nodes.size - 1;
    } else {
      rolesCount = document.nodes.size;
    }

    return (
      <>
        {snackBar && (
          <SnackBarAlerts
            showSnackBar={snackBar.showSnackBar}
            handleClose={this.handleCloseSnackBar}
            snackBarMessage={snackBar.snackBarMessage}
            snackBarType={snackBar.snackBarType}
          />
        )}
        <ArrayItemWrapper
          className="array-items"
          data-testId="array-items"
          {...attributes}
          nodeType={currentNodeType}
          draggable
          onDragStart={this.onDragStart}
          onDragEnd={this.onDragEnd}
          isFocused={isFocused}
          isSafari={isSafari}
          rolesCount={rolesCount}
        >
          <DragWrapper
            className="drag-signifier-array-item"
            title="Drag to reorder"
            type={currentNodeType}
            contentEditable={false}
            onMouseDown={() => this.setDragState(false)}
          >
            <DragHandler width="20px" height="20px" />
          </DragWrapper>

          {currentNodeType === 'personal_link' && (
            <PersonalLinkIconSelector
              editor={editor}
              node={node}
              formatType={formatType}
            />
          )}

          <Input
            currentNodeType={currentNodeType}
            nodeProps={nodeProps}
            placeHolder={placeHolder}
            userPreferences={userPreferences}
            stopDrag={this.stopDrag}
            isFocused={isFocused}
            isSafari={isSafari}
            showRatings={showRatings}
            sectionKey={sectionKey}
            formatType={formatType}
            statusBarRef={statusBarRef}
            mostUsedToolSetRef={mostUsedToolSetRef}
            rolesCount={rolesCount}
          />
          <Export
            editor={editor}
            node={node}
            dataTestId={currentNodeType}
            formatType={formatType}
            contentEditable={false}
          />
        </ArrayItemWrapper>
      </>
    );
  }
}

ArrayItem.propTypes = {
  nodeProps: propTypes.objectOf(propTypes.object).isRequired,
  placeHolder: propTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { formatType, sectionKey } = ownProps;
  const common = {
    activePlan: state.userInfoReducer.activePlan,
    subscriptionStatus: state.userInfoReducer.subscriptionStatus,
  };

  if (formatType === FormatTypes.RESUME) {
    return {
      userPreferences: state.editResumeFormReducer.userPreferences,
      showRatings: state.editResumeFormReducer.userPreferences.showRatings,
      dragOverCords: state.editResumeFormReducer.dragOverCords,
      [sectionKey]: state.editResumeFormReducer[sectionKey], // re-renders skill title when there is an update in rolesCount properties
      ...common,
    };
  }

  if (formatType === FormatTypes.COVER_LETTER) {
    return {
      userPreferences: state.editCoverLetterFormReducer.userPreferences,
      [sectionKey]: state.editCoverLetterFormReducer[sectionKey], // re-renders skill title when there is an update in rolesCount properties
      ...common,
    };
  }

  return null;
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { formatType } = ownProps;

  if (formatType === FormatTypes.RESUME) {
    return {
      setDrag: (params) =>
        dispatch(Actions.editResumeFormActions.setDrag(params)),
    };
  }

  if (formatType === FormatTypes.COVER_LETTER) {
    return {
      setDrag: (params) =>
        dispatch(Actions.editCoverLetterFormActions.setDrag(params)),
    };
  }

  return null;
};

export default connect(mapStateToProps, mapDispatchToProps)(ArrayItem);
